// extracted by mini-css-extract-plugin
export default {"history":"mD9f_zknyLW9aXA6r8SN","historyHeading":"zwzC01g9DiHV68oZi_Ci","historyLoader":"X8jo0KJDSU6VAn4nextQ"};